export interface AppProps {
    BASE_URL: string;
}

// @ts-ignore
const appProps: AppProps = window.configs as AppProps;

export default appProps;